import { render } from "./all_query_listing.vue?vue&type=template&id=2d8d061f"
import script from "./all_query_listing.vue?vue&type=script&lang=js"
export * from "./all_query_listing.vue?vue&type=script&lang=js"

import "./all_query_listing.vue?vue&type=style&index=0&id=2d8d061f&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__